import $axios from "../api/accessor";
import { $api } from "../api/api";

export const GeoService = {
  autocomplete: (input: string, lang = "az") =>
    $axios.post($api("geo_autocomplete"), { city_id: "5", lang, input }),

  reverseGeocode: (latitude: number, longitude: number, lang = "az") =>
    $axios.post($api("geo_reverse"), { latitude, longitude, lang, city_id: "5" }),
};
